export const MODULE = 'AUTH';
export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const LOGIN = 'LOGIN';
export const LOGIN_REQUEST = `${MODULE}/${LOGIN}_${REQUEST}`;
export const LOGIN_SUCCESS = `${MODULE}/${LOGIN}_${SUCCESS}`;
export const LOGIN_FAILURE = `${MODULE}/${LOGIN}_${FAILURE}`;
